const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.522,1.97H4.478A2.511,2.511,0,0,0,1.97,4.478V19.522A2.511,2.511,0,0,0,4.478,22.03H19.522a2.511,2.511,0,0,0,2.508-2.508V4.478A2.511,2.511,0,0,0,19.522,1.97Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.767,9.3a3.678,3.678,0,0,1-2.209-.737V13.6a4.164,4.164,0,1,1-3.593-4.126V11.1a2.6,2.6,0,1,0,1.823,2.482V5.731h1.77a2.4,2.4,0,0,0,2.209,2.141Z",
    style: {
      fill: "#25f4ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.688,8.741a3.678,3.678,0,0,1-2.209-.737v5.032a4.164,4.164,0,1,1-3.593-4.126v1.626a2.6,2.6,0,1,0,1.823,2.482V5.731h1.77a2.4,2.4,0,0,0,2.209,2.141Z",
    style: {
      fill: "#fe2c55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.23,9.02a3.678,3.678,0,0,1-2.209-.737v5.032a4.164,4.164,0,1,1-3.593-4.126v1.626a2.6,2.6,0,1,0,1.823,2.482V5.731h1.77A2.4,2.4,0,0,0,17.23,7.872Z",
    style: {
      fill: "#fafbfc"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokSquare);
export default __webpack_public_path__ + "static/media/tiktok_square.80af9f87897fa664969b58a48b5dcae8.svg";
export { ForwardRef as ReactComponent };